import { produce } from 'immer';
import type { StoreApi } from 'zustand';
import type { DraftState, State } from '../../reducers';
import type { EventsActions } from '../events_reducers';

export const createModalActions = (
  set: StoreApi<State>['setState'],
): Pick<
  EventsActions,
  'openPaymentModal' | 'closePaymentModal' | 'openStarterSyncModal' | 'closeStarterSyncModal'
> => ({
  openPaymentModal: () => {
    set(
      produce((s: DraftState) => {
        s.events.showPaymentModal = true;
      }),
    );
  },
  closePaymentModal: () => {
    set(
      produce((s: DraftState) => {
        s.events.showPaymentModal = false;
      }),
    );
  },
  openStarterSyncModal: () => {
    set(
      produce((s: DraftState) => {
        s.events.showStarterSyncModal = true;
      }),
    );
  },
  closeStarterSyncModal: () => {
    set(
      produce((s: DraftState) => {
        s.events.showStarterSyncModal = false;
      }),
    );
  },
});
